import MobileLayout from './RoadmapDescriptionLayout.mobile';
import WebLayout from './RoadmapDescriptionLayout.web';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
